/**
 * Ce qu'une zone de barème vaut, en toutes lettres.
 *
 * *Sorti de `Chantiers.tsx` le 18/09/2026*, quand la saisie des heures a eu besoin de la même
 * phrase : la colonne « Zone transport » de la journée propose les mêmes tranches que la fiche du
 * chantier, et deux façons d'écrire « 3,71 € » ou « 50,00 % du brut » dans deux écrans qui parlent
 * du même barème se liraient comme deux barèmes.
 *
 * Il y a une seconde raison, moins visible : les trois cas — une part de salaire, un montant, et
 * **ni l'un ni l'autre** — sont une règle, pas un formatage. Le troisième est celui qui compte, et
 * c'est celui qu'une seconde implémentation aurait oublié.
 */
import { formaterMontant, formaterNombre } from "@planif/moteur";
import type { ZoneProposee } from "@planif/moteur";

export function valeurDeLaZone(zone: ZoneProposee): string {
  // Deux décimales, comme la colonne : « 50 % » s'écrit 50,00 en base, et un barème qui
  // porterait 12,50 % ne doit pas s'afficher 13 %.
  if (zone.partSalaireBrut !== null)
    return `${formaterNombre(zone.partSalaireBrut, 2)} % du brut`;
  if (zone.montant !== null) return `${formaterMontant(zone.montant)} €`;
  // Ni montant ni part : le barème est incomplet, et le dire vaut mieux qu'un blanc — c'est la
  // règle du zéro qui ne se confond avec rien.
  return "montant non renseigné";
}
